import { colorPrimitives } from '../primitives/colors';

/** Semantic color tokens — map Figma palettes to Chakra `colorPalette` slots. */
export const semanticColors = {
  bg: {
    DEFAULT: { value: '{colors.neutral.0}' },
  },
  fg: {
    DEFAULT: { value: '{colors.neutral.500}' },
    error: { value: '{colors.red.600}' },
    muted: { value: '{colors.neutral.250}' },
  },
  border: {
    DEFAULT: { value: '{colors.neutral.200}' },
    subtle: { value: '{colors.neutral.100}' },
  },
  blue: {
    solid: { value: '{colors.blue.500}' },
    fg: { value: '{colors.blue.500}' },
    muted: { value: '{colors.blue.500}' },
    subtle: { value: '{colors.blue.50}' },
    border: { value: '{colors.neutral.200}' },
  },
  brand: {
    solid: { value: '{colors.brand.500}' },
    contrast: { value: '{colors.neutral.0}' },
    // Brand-colored text on a white page. A portfolio's pale primary is darkened at runtime until it reads at 4.5:1 on white.
    text: { value: '{colors.brand.500}' },
    fg: { value: '{colors.brand.700}' },
    muted: { value: '{colors.brand.50}' },
    subtle: { value: '{colors.brand.100}' },
    emphasized: { value: '{colors.neutral.200}' },
    border: { value: '{colors.neutral.200}' },
    focusRing: { value: '{colors.brand.500}' },
    // Marker and highlight on a dark brand surface. A portfolio's primary color swaps in its own accent at runtime.
    accent: { value: '{colors.neonGreen.500}' },
    // Text on `brand.accent`, not `brand.solid` (that is `brand.contrast`). A portfolio swaps in white or neutral black.
    onAccent: { value: '{colors.brand.700}' },
  },
  // Success and "low" statuses. They hold hex values, not `brand.*` references, so a brand variable can never
  // recolor them. A portfolio's primary color swaps in a generic green at runtime, see BRANDED_STATUS_CSS_VARIABLES.
  success: {
    subtle: { value: colorPrimitives.accent[50] },
    fg: { value: colorPrimitives.primary[800] },
    solid: { value: colorPrimitives.primary[400] },
  },
  neonGreen: {
    solid: { value: '{colors.neonGreen.500}' },
    contrast: { value: '{colors.neutral.500}' },
    fg: { value: '{colors.neonGreen.700}' },
    muted: { value: '{colors.neonGreen.50}' },
    subtle: { value: '{colors.neonGreen.100}' },
    emphasized: { value: '{colors.neutral.200}' },
    border: { value: '{colors.neutral.200}' },
    focusRing: { value: '{colors.neonGreen.500}' },
  },
  neutral: {
    solid: { value: '{colors.neutral.100}' },
    contrast: { value: '{colors.neutral.500}' },
    fg: { value: '{colors.neutral.500}' },
    muted: { value: '{colors.neutral.0/10}' },
    subtle: { value: '{colors.neutral.200}' },
    emphasized: { value: '{colors.neutral.200}' },
  },
  green: {
    solid: { value: '{colors.green.500}' },
    fg: { value: '{colors.green.500}' },
    muted: { value: '{colors.green.500}' },
    subtle: { value: '{colors.green.100}' },
  },
  red: {
    solid: { value: '{colors.red.500}' },
    fg: { value: '{colors.red.500}' },
    muted: { value: '{colors.red.500}' },
    subtle: { value: '{colors.red.100}' },
  },
  orange: {
    solid: { value: '{colors.orange.500}' },
    fg: { value: '{colors.orange.500}' },
    muted: { value: '{colors.orange.500}' },
    subtle: { value: '{colors.orange.100}' },
  },
};
